// The board's own masthead: a card with the section line, the title, and on the right how fresh
// the data is. Nothing here links to, or
// mentions, any other board.

import { formatPacificTime } from '../board/format.ts';

// The build runs twice a day, so data more than a day old means a refresh has failed.
const STALE_DATA_MS = 24 * 60 * 60 * 1000;
const HOUR_MS = 60 * 60 * 1000;

// "3.2h ago", or "2d ago" once it's more than a day.
function syncAge(salesforceThrough: string, now: number): string {
  const hours = (now - Date.parse(salesforceThrough)) / HOUR_MS;
  if (hours < 1) return 'under an hour ago';
  if (hours < 48) return `${hours.toFixed(1)}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

function Freshness({ salesforceThrough }: { salesforceThrough: string }) {
  const now = Date.now();
  const stale = now - Date.parse(salesforceThrough) >= STALE_DATA_MS;
  return (
    <p className="freshness" title={`The latest Salesforce sync this board was built from: ${formatPacificTime(salesforceThrough)}`}>
      <span className={'freshness-dot' + (stale ? ' is-stale' : '')} aria-hidden="true" />
      Salesforce synced <time dateTime={salesforceThrough}>{syncAge(salesforceThrough, now)}</time>
    </p>
  );
}

// Said in words as well, under the masthead, when the data is more than a day old.
export function StaleDataBanner({ salesforceThrough }: { salesforceThrough: string }) {
  const ageMs = Date.now() - Date.parse(salesforceThrough);
  if (ageMs < STALE_DATA_MS) return null;
  return (
    <p className="notice notice-warn" role="status">
      <b>This data is more than a day old.</b> It's from {formatPacificTime(salesforceThrough)}; the
      twice-daily refresh from Salesforce may have failed.
    </p>
  );
}

export function Masthead({ salesforceThrough }: { salesforceThrough: string | null }) {
  return (
    <header className="masthead">
      <div>
        <p className="masthead-section">
          <span className="masthead-brand">Cartesia</span>
          <span className="masthead-divider" aria-hidden="true" />
          <span>GTM</span>
        </p>
        <h1>Opportunities <span className="masthead-accent">Dashboard</span></h1>
      </div>
      <div className="masthead-side">
        {salesforceThrough ? <Freshness salesforceThrough={salesforceThrough} /> : null}
      </div>
    </header>
  );
}
